import _ from "lodash";
import { Alert, Container, Row, Col } from "reactstrap";
import { Component as Modal, useModalState } from "@repoflow/form-schema/modal";
import { useMutation } from "@apollo/client";
import * as Loading from "@repoflow/components/loading";
import * as NotifyUtils from "@repoflow/form-schema/notify";

export const ConfirmModal = ({
  className = "btn btn-link",
  label,
  onConfirm,
  children,
  confirmation,
}) => {
  const modal = useModalState(false);

  return (
    <>
      <button className={className} onClick={() => modal.open()}>
        {label}
      </button>

      <Modal title={label} state={modal}>
        <Container>
          <Row>
            <Col>{children}</Col>
          </Row>

          <Row>
            <Col>
              <Alert color="danger" fade={false}>
                {confirmation}
              </Alert>
            </Col>
          </Row>

          <Row>
            <Col>
              <div className="float-right">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    onConfirm && onConfirm();
                    modal.close();
                  }}
                  className={"btn btn-danger"}
                >
                  Confirm
                </button>
              </div>

              <button
                type="button"
                className="btn btn-secondary"
                onClick={(e) => {
                  e.preventDefault();
                  modal.close();
                }}
              >
                Cancel
              </button>
            </Col>
          </Row>
        </Container>
      </Modal>
    </>
  );
};

export const ConfirmMutationModal = (props) => {
  const { mutation, variables, update, children, onCompleted, onError } = props;

  const [handler, { loading, error }] = useMutation(mutation, {
    update,
    onCompleted: (data) => onCompleted && onCompleted(data),
    onError: (error) => {
      onError ? onError(error) : NotifyUtils.error(error.toString());
    },
  });

  return loading ? (
    <Loading.Content />
  ) : (
    <ConfirmModal
      {...props}
      onConfirm={() => {
        handler({ variables });
      }}
    >
      {children}
    </ConfirmModal>
  );
};
